import React, { useContext, useState } from "react";
import { useSelector } from "@xstate/react";
import { SignUpFormField } from "../../constants/signup-form-field.enum";
import { useSignUpMachine } from "../../context/SignUpMachineContext";
import TextInput, { isValidTextInput } from "../TextInput";
import { Button } from "../SignUpButton";
import { Loader } from "@pushpress/shared-components";
import { BalancedStepTitle } from "../BalancedStepTitle";
import HubspotContext from "../../../../context/hubspot";
import { BalancedStepSubtitle } from "../BalancedStepSubtitle";

const EmailStep: React.FC = () => {
  const service = useSignUpMachine();
  const formData = useSelector(service, (state) => state.context.formData);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { identifyHubspotUser } = useContext(HubspotContext);

  const handleChange = (value: any) => {
    service.send({
      type: "UPDATE_FORM",
      data: {
        [SignUpFormField.Email]: value,
      },
    });
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      identifyHubspotUser(formData[SignUpFormField.Email]);
      service.send({ type: "NEXT" });
    } catch (error) {
      console.error("Error submitting email:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const canProceed = isValidTextInput(formData[SignUpFormField.Email], "email");

  return (
    <>
      <div className="tw-flex tw-flex-col tw-items-center tw-space-y-1 tw-text-center">
        <BalancedStepTitle title="Schedule a Demo" />
        <BalancedStepSubtitle subtitle="Take a quick tour and see what's possible with PushPress." />
      </div>
      <div className="tw-space-y-4">
        <TextInput
          id={SignUpFormField.Email}
          value={formData[SignUpFormField.Email]}
          onChange={handleChange}
          inputType="email"
          label="Email address"
          required={true}
          disabled={isSubmitting}
          placeholder="admin@mygym.com"
        />
      </div>
      <div className="tw-flex tw-justify-between tw-items-center">
        <Button
          onClick={handleSubmit}
          disabled={!canProceed || isSubmitting}
          size="fat"
          className="tw-uppercase tw-tracking-widest tw-w-full tw-flex tw-py-4 tw-items-center tw-gap-2 tw-text-white"
        >
          {isSubmitting ? <Loader color="white" /> : <span>Continue</span>}
        </Button>
      </div>
    </>
  );
};

export default EmailStep;
